import { Component, OnInit, ViewChild } from '@angular/core';
import { AdminViewModel } from 'src/app/models/AdminViewModel';
import { AdminService } from 'src/app/public/landing/services/admin.service';
import { AuthService } from 'src/app/core-services/auth.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { FormBuilder, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { ElementRef } from '@angular/core';
import { PortlistModel } from 'src/app/models/portlist-model';
//import { PortAlias } from 'src/app/models/port-alias';
import { PortAlias } from 'src/app/models/port-alias';
import { PortSearchRequestModel } from 'src/app/models/portSearchRequestModel';
import { PortService } from 'src/app/core-services/port.service';
import { openLoginModal } from 'src/app/core-services/eventEmitter';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-port-list',
  templateUrl: './port-list.component.html',
  styleUrls: ['./port-list.component.scss']
})
export class PortListComponent implements OnInit {
  requestVM: PortSearchRequestModel;
  portData: any;
  PortId: number = 0;
  PortAliasId: number = 0;
  totalcount: number = 0;
  countries: any = [];
  portAliasList: any = [];
  countriesname: any = [];
  countriesList: any[];
  regions: any = [];
  aliase: any = [];
  portName: string;
  aliasName: string;
  submitted: boolean = false;
  selectedCountry: any;
  selectedRegion: any;
  selectedPortStatus: any;
  isPortlistSaved: boolean = true;
  dataSaved = false;
  isDuplicateUNCode: boolean = false;

  portStatus: any[] = [
    { value: null, viewValue: 'All' },
    { value: true, viewValue: 'Active' },
    { value: false, viewValue: 'In-Active' }
  ]

  get f() { return this.PortForm.controls; }

  PortForm = this.fb.group({
    portName: ['', [Validators.required]],
    portCode: ['', [Validators.required]],
    portCountryId: ['', Validators.required],
    isPortCallRegister: [false]

  });
  get fg() { return this.PortAlias.controls; }

  PortAlias = this.fb.group({
    id: ['', Validators.required],
    portId: ['', Validators.required],
    portaliasesName: ['', [Validators.required]],
  });
  constructor(private fb: FormBuilder, private toastr: ToastrService, private adminService: AdminService,
    private authenticationService: AuthService, private spinner: NgxSpinnerService,
    private portService: PortService,
  private modalService: NgbModal) { }

  ngOnInit() {
    this.requestVM = new AdminViewModel();
    this.requestVM.pageNo = 1;
    this.requestVM.pageSize = 10;

    let portActivationStatus = this.portStatus.filter(x => x.value == true);
    this.selectedPortStatus = portActivationStatus[0];

    this.getRegions();
    this.getCountries();
    this.getPortList();
  }
  // @ViewChild('closePortModal') closePortModal: ElementRef;
  @ViewChild('closePortAliases') closePortAliases: ElementRef;
  @ViewChild('portModal', { static: false }) portModal: any;
  @ViewChild('aliasModal', { static: false }) aliasModal: any;
  @ViewChild('viewAliasModal', { static: false }) viewAliasModal: any;
  modalRef: NgbModalRef | null = null;
  portModalMode: 'add' | 'edit' = 'add';

  getPortList() {
    if (this.requestVM != null && this.requestVM.pageNo > 0 && this.requestVM.pageSize > 0) {
      this.spinner.show();
      this.portService.GetPortsList(this.requestVM).subscribe((response: any) => {
        if (response != null && response.data != null) {
          this.portData = response.data;
          this.totalcount = response.totalRecords;
          this.spinner.hide();
        }
        else if(response.code =='401'){
          openLoginModal();
          }
        this.spinner.hide();
      });
    }
  }

  openPortModal(id: number, mode: 'add' | 'edit') {
    this.portModalMode = mode;
    this.getPortdetails(id, mode); 

    this.modalRef = this.modalService.open(this.portModal, {
      size: 'lg',
      centered: true,
      backdrop: 'static'
    });
  }

  closePortModal() {
    if (this.modalRef) {
      this.modalRef.close();
    }
  }

  openAliasModal(portId: number) {
    this.getPortAliasDetails(0, portId);
    this.modalService.open(this.aliasModal, {
      size: 'lg',
      centered: true,
      backdrop: 'static'
    });
  }  

  openAliasModalView(portId, portName) {
    this.getAllportalias(portId, portName);
    this.modalService.open(this.viewAliasModal, {
      size: 'lg',
      centered: true,
      backdrop: 'static'
    });
  }

  paginate(event) {
    this.requestVM.pageNo = event.page + 1;
    this.requestVM.pageSize = event.rows;
    this.getPortList();
  }
  filterSearch(searchText) {
    this.requestVM.pageNo = 1;
    this.requestVM.pageSize = 10;
    this.requestVM.searchText = searchText;
    this.getPortList();
  }
  getCountries() {
    this.authenticationService.getAllCountries().subscribe((response: any) => {
      if (response != null && response.content != null) {
        this.countries = response.content;
        this.countriesList = response.content;
        // this.countriesname = response.content;
      }
    })
  }
  getRegions() {
    this.adminService.getRegions().subscribe((response: any) => {
      if (response != null && response.content != null) {
        this.regions = response.content;
      }
    })
  }
  onChangeRegion() {
    if (this.selectedRegion != null && this.selectedRegion != undefined && this.selectedRegion.id > 0) {
      this.countries = this.countriesList.filter(x => x.regionId == this.selectedRegion.id)
      this.requestVM.pageNo = 1;
      this.requestVM.pageSize = 10;
      this.requestVM.regionId = this.selectedRegion.id;
    }
    else {
      this.countries = this.countriesList;
      this.requestVM.pageNo = 1;
      this.requestVM.pageSize = 10;
      this.requestVM.regionId = this.selectedRegion.id;
    }
    this.selectedCountry = null;
    this.requestVM.countryId = 0
    this.getPortList();
  }

  onChangeCountry() {
    if (this.selectedCountry != null && this.selectedCountry != undefined && this.selectedCountry.id > 0) {
      this.requestVM.pageNo = 1;
      this.requestVM.pageSize = 10;
      this.requestVM.countryId = this.selectedCountry.id;
    }
    else {
      this.requestVM.pageNo = 1;
      this.requestVM.pageSize = 10;
      this.requestVM.countryId = this.selectedCountry.id;
    }
    this.getPortList();
  }

  onChangePortStatus() {
    this.requestVM.IsPortCall = this.selectedPortStatus.value;
    this.requestVM.pageNo = 1;
    this.requestVM.pageSize = 10;
    this.getPortList();
  }

  getPortdetails(id, actioon) {

    if (actioon == 'edit') {
      this.PortId = id;
      this.portService.GetPortdetailsByPortId(this.PortId).subscribe((response: any) => {
        if (response != null && response.data) {
          this.PortForm.controls.portName.setValue(response.data.portName);
          this.PortForm.controls.portCode.setValue(response.data.portCode);
          this.countriesname = this.countries.filter(x => x.id == response.data.portCountryId)
          if (this.countriesname != null && this.countriesname.length > 0) {
            this.PortForm.controls.portCountryId.setValue(this.countriesname[0]);
          }
          this.PortForm.controls.isPortCallRegister.setValue(response.data.isPortCallRegister);
        }
        else {
          this.toastr.error('Something went wrong!', 'Oops!!');
        }
      });
    }
    else if (id == 0 && actioon == 'add') {
      this.PortId = id;
      this.PortForm.reset();
    }
    else {
      this.PortAlias.reset();
      this.PortAlias.controls.portId.setValue(id);
    }

  }


  getPortAliasDetails(id, portId) {
    this.PortAliasId = id;
    this.PortAlias.reset();
    this.PortAlias.controls.portId.setValue(portId);
    this.PortAlias.controls.id.setValue(id);
    if (id > 0) {
      let portAlias = this.portAliasList.filter(x => x.id == id);
      this.PortAlias.controls.portaliasesName.setValue(portAlias[0].portAliasName);
    }
  }

  resetPortAliasForm() {
    this.PortAlias.reset();
    this.PortAliasId = null;
  }

  Reset() {
    this.PortForm.reset();
  }
  resetvalues() {
    this.submitted = false;
    this.PortForm.reset();
    this.isPortlistSaved = true;
  }
  updateport() {
    this.submitted = true;
    if (this.PortForm.invalid || !this.PortId) {
      this.toastr.warning('All fields the Required.', 'Oops !');
      return;
    }
    else {
      if (this.isDuplicateUNCode == true) {
        this.toastr.warning('UN Code is exist in system.', 'Oops !');
        return;
      }
      let model: any = new PortlistModel();
      model.Id =  this.PortId;
      model.PortName = (this.PortForm.controls.portName.value);
      model.PortCode = (this.PortForm.controls.portCode.value);
      model.PortCountryId = parseInt((this.PortForm.controls.portCountryId.value as any)?.id);
      model.IsPortCallRegister = this.PortForm.controls.isPortCallRegister.value? Boolean(this.PortForm.controls.isPortCallRegister.value): false;
      this.portService.UpdatePort(model).subscribe((response: any) => {
        if (response != null && response.succeeded) {
          this.modalRef?.close(); 
          this.toastr.success(response.message, 'Info');
        }
        this.getPortList();
      })
    }
  }

  addPort() {
    if (this.PortForm.invalid) {
      this.getFormError();
      return;
    }
    else {
      if (this.isDuplicateUNCode == true) {
        this.toastr.warning('UN Code is exist in system.', 'Oops !');
        return;
      }
      let model:any = new PortlistModel();
      model.PortName = (this.PortForm.controls.portName.value);
      model.PortCode = (this.PortForm.controls.portCode.value);
      model.PortCountryId = parseInt((this.PortForm.controls.portCountryId.value as any)?.id);
      model.IsPortCallRegister =this.PortForm.controls.isPortCallRegister.value? Boolean(this.PortForm.controls.isPortCallRegister.value): false;
      this.portService.AddPort(model).subscribe((response: any) => {
        if (response != null && response.succeeded) {
          this.modalRef?.close(); 
          this.toastr.success(response.message, 'Info');
        }
        this.getPortList();
      })
    }
  }

  checkDuplicateUNCode() {
    if (this.PortForm.controls.portCode.value != null && this.PortForm.controls.portCode.value != '') {
      this.portService.CheckDuplicatePortCode(this.PortForm.controls.portCode.value).subscribe((response: any) => {
        if (response != null && response.data) {
          this.isDuplicateUNCode = true;
          this.toastr.warning(response.message, 'Info');
        }
      });
    }
  }

  AddPortAlias() {
    this.submitted = true;
    if (this.PortAlias.invalid) {
      // this.toastr.warning('Please Enter Field.', 'Oops !');
      return;
    }
    else {
      let prtModel:any = new PortAlias();
      this.isPortlistSaved = false;
      prtModel.PortId = this.PortAlias.controls.portId.value;
      prtModel.Id = this.PortAlias.controls.id.value;
      prtModel.PortAliasName = (this.PortAlias.controls.portaliasesName.value);
      if (prtModel != null && prtModel.PortId > 0 && prtModel.PortAliasName != null && prtModel.PortAliasName != '') {
        if (prtModel.Id) {
          this.portService.UpdatePortAlias(prtModel).subscribe((response: any) => {
            if (response != null && response.succeeded) {
              this.getAllportalias(prtModel.PortId, "");
              // this.closePortAliases.nativeElement.click();
              this.modalRef.close();
              this.toastr.success('Record saved sucessfully..!', '');
            }
            this.getPortList();
          })
        } else {
          this.portService.AddPortAlias(prtModel).subscribe((response: any) => {
            if (response != null && response.succeeded) {
              this.getAllportalias(prtModel.PortId, "");
              // this.closePortAliases.nativeElement.click();
              this.modalRef.close();
              this.toastr.success('Record saved sucessfully..!', '');
            }
            this.getPortList();
          })
        }
      }
    }
  }

  getAllportalias(id, portName) {
    this.PortId = id;
    this.portName = portName;
    this.portAliasList = [];
    this.portService.GetPortAlias(this.PortId).subscribe((response: any) => {
      if (response != null && response.data) {
        this.portAliasList = response.data;

      }
      else {
        this.portAliasList = null;
        // this.toastr.error(response.message);
      }
    })
  }

  deletePortAlias(id, portId) {
    this.portService.DeletePortAlias(id).subscribe((response: any) => {
        this.getAllportalias(portId, "");
        this.toastr.success('Record deleted sucessfully..!', '');
    });
  }

  private getFormError(){
    if (this.PortForm.controls.portName.status == 'INVALID') {
      this.toastr.error("Port name is required.", "Error!");
      return;
    }
    if (this.PortForm.controls.portCode.status == 'INVALID') {
      this.toastr.error("Port code is required.", "Error!");
      return;
    }

    if (this.PortForm.controls.portCountryId.status == 'INVALID') {
      this.toastr.error("Country is required.", "Error!");
      return;
    }      
  } 
}




